
const validateNumber = (
  value: string,
  min: number,
  max: number,
) => value !== '' && Number(value) >= min && Number(value) <= max

const state = {
  brand_id: undefined,
  cmyk: {
    c: '',
    k: '',
    m: '',
    y: '',
  },
  id: null,
  rgb: {
    b: '',
    g: '',
    r: '',
  },
  spot_colour_name: '',
  title: '',
}

export const requiredFields = [
  { key: 'brand_id' },
  { key: 'cmyk.c', validation: (value: string) => validateNumber(value, 0, 100), invalidMessage: 'Invalid Number' },
  { key: 'cmyk.m', validation: (value: string) => validateNumber(value, 0, 100), invalidMessage: 'Invalid Number' },
  { key: 'cmyk.y', validation: (value: string) => validateNumber(value, 0, 100), invalidMessage: 'Invalid Number' },
  { key: 'cmyk.k', validation: (value: string) => validateNumber(value, 0, 100), invalidMessage: 'Invalid Number' },
  { key: 'rgb.r', validation: (value: string) => validateNumber(value, 0, 255), invalidMessage: 'Invalid Number' },
  { key: 'rgb.g', validation: (value: string) => validateNumber(value, 0, 255), invalidMessage: 'Invalid Number' },
  { key: 'rgb.b', validation: (value: string) => validateNumber(value, 0, 255), invalidMessage: 'Invalid Number' },
  { key: 'title' },
]

export default state
